import React, { useCallback, useMemo, useState } from "react";
import Context from "./context";

const processConfig = (config) => {
  if (
    !config ||
    !config.form ||
    !Array.isArray(config.form.sections) ||
    !config.form.fields
  ) {
    return config;
  }

  const fieldsMap = {};

  for (let i = 0; i < config.form.sections.length; i++) {
    const sectionId = config.form.sections[i].id;
    const fields = config.form.fields[sectionId];
    if (!Array.isArray(fields)) {
      continue;
    }
    for (let j = 0; j < fields.length; j++) {
      const field = fields[j];
      fieldsMap[field.id] = field;
    }
  }
  return { ...config, form: { ...config.form, fieldsMap } };
};

const Store = ({ children }) => {
  const [state, setState] = useState({
    config: null,
    incidents: null,
    memberList: null,
    tags: [],
    charts: null,
  });

  const setConfig = useCallback((config) => {
    setState((prev) => ({ ...prev, config: processConfig(config) }));
  }, []);

  const setMembers = useCallback((members) => {
    setState((prev) => ({ ...prev, memberList: members }));
  }, []);

  const setTags = useCallback((tags) => {
    setState((prev) => ({ ...prev, tags }));
  }, []);

  const setIncidents = useCallback((incidents) => {
    setState((prev) => ({ ...prev, incidents }));
  }, []);

  const updateIncident = useCallback((incident) => {
    setState((prev) => {
      if (!prev.incidents) {
        return prev;
      }
      const updatedIncidents = prev.incidents.map((item) =>
        item.id === incident.id ? incident : item
      );
      return { ...prev, incidents: updatedIncidents };
    });
  }, []);

  const setCharts = useCallback((charts) => {
    setState((prev) => ({ ...prev, charts }));
  }, []);

  const actions = useMemo(
    () => ({
      setConfig,
      setMembers,
      setTags,
      setIncidents,
      updateIncident,
      setCharts,
    }),
    [
      setConfig,
      setMembers,
      setTags,
      setIncidents,
      updateIncident,
      setCharts,
    ]
  );

  return (
    <Context.Provider value={{ state, actions }}>{children}</Context.Provider>
  );
};

export default Store;
